import React from 'react'
import Edit from '../crud/edit'
import fields from './fields'
import menuItems from './menuItems'

const EditPrivateCoaching = (props) => {
  return (
    <Edit
// @ts-ignore
      title='Edit Private Coaching'
      fields={fields}
      apiPath={`admin/private_coachings/${props.params.privateCoachingId}`}
      successRedirectPath='/write-now/private_coachings'
      buildMenuItems={menuItems}
    />
  )
}

export default EditPrivateCoaching
